import React, { useRef, useEffect, useState } from 'react';
import { useMapsLibrary } from '@vis.gl/react-google-maps';

export const GoogleAutocomplete = ({ location, onPlaceSelect }) => {
    const [placeAutocomplete, setPlaceAutocomplete] = useState(null);
    const [geoLocatorVisible, setGeoLocatorVisible] = useState(true);
    const [locationName, setLocationName] = useState(location);

    const inputRef = useRef(null);
    const places = useMapsLibrary('places');

    useEffect(() => {
        if (!places || !inputRef.current) return;

        const options = {
            fields: ['geometry'],
            componentRestrictions: {
                country: 'gb',
            }
        };

        setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));
    }, [places]);

    useEffect(() => {
        if (!placeAutocomplete) return;

        placeAutocomplete.addListener('place_changed', () => {
            onPlaceSelect(placeAutocomplete.getPlace());
        });
    }, [onPlaceSelect, placeAutocomplete]);

    function mightBeCleared() {
        inputRef?.current.value === '' && onPlaceSelect(null);
    }

    async function getLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    await fetch(
                        `https://api.postcodes.io/outcodes?lon=${position.coords.longitude}&lat=${position.coords.latitude}`,
                        {
                            method: "get",
                        }
                    ).then((response) => {
                        if (response.status < 200 || response.status >= 400) {
                            throw "There was an error retrieving your location. Please try again, or enter manually.";
                        }

                        response
                            .text()
                            .then((text) => {
                                const { status, result } = tryParseJSON(text);

                                if (
                                    status !== 200 ||
                                    !result ||
                                    result.length === 0
                                ) {
                                    throw "There was an error retrieving your location. Please try again, or enter manually.";
                                }

                                inputRef.current.value = result[0].outcode;
                                //setLocationName(result[0].outcode);
                                onPlaceSelect({ geocode: result[0] });
                            })
                            .catch((e) => {
                                alert(e);
                            });
                    });
                }
            );
        } else {
            setGeoLocatorVisible(false);
        }
    }

    function tryParseJSON(jsonString) {
        try {
            const o = JSON.parse(jsonString);
            if (o && typeof o === "object") {
                return o;
            }
        } catch (e) { }

        return JSON.parse("[]");
    }

    return (
        <>
            <input ref={inputRef} id="Location" name="Location" placeholder="e.g. location, postcode, street name" onInput={mightBeCleared}
                onChange={e => e.stopPropagation()} type="search" autoComplete="off" defaultValue={locationName}
                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }} />
            <button type="button" className={geoLocatorVisible ? "absolute" : "hide"} onClick={getLocation}>
                <svg className="icon">
                    <use href="#compass"></use>
                </svg>
                <span className="show-for-sr">Use my location</span>
            </button>
        </>
    );
};
